export enum AdminShipmentSizeType {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
